/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_CreatedInputs */

const en_cargo_created = /** @type {(inputs: Cargo_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo created`)
};

const es_cargo_created = /** @type {(inputs: Cargo_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga creada`)
};

/**
* | output |
* | --- |
* | "Cargo created" |
*
* @param {Cargo_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_created = /** @type {((inputs?: Cargo_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_created(inputs)
	return es_cargo_created(inputs)
});